import { render } from "./TouchesListModal.vue?vue&type=template&id=c32f7f32"
import script from "./TouchesListModal.vue?vue&type=script&lang=js"
export * from "./TouchesListModal.vue?vue&type=script&lang=js"

import "./TouchesListModal.vue?vue&type=style&index=0&id=c32f7f32&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__